import type { KnockoutTree } from "@motain/xpa-proto-files-web/lib/types/kotree";
import type { FC } from "react";
import { useState } from "react";
import { KoTreeStage } from "@/xpa-components/ko-tree/ko-tree-stage/KoTreeStage";
import styles from "./KoTree.module.scss";
import { createKoTreeArrayShape } from "@/xpa-components/ko-tree/createKoTreeArrayShape";

export const KoTree: FC<KnockoutTree> = (props) => {
  const { stages } = props;
  const [mutatedStages, _] = useState(createKoTreeArrayShape(stages));

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {mutatedStages.map((stage, index) => {
          return (
            <li key={index} className={styles.listElement}>
              <KoTreeStage {...stage} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
